import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout, RequireAuth, RequireAdmin } from "@/components/Layout";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Banned from "@/pages/Banned";
import ListingDetail from "@/pages/ListingDetail";
import CreateListing from "@/pages/CreateListing";
import EditListing from "@/pages/EditListing";
import MyListings from "@/pages/MyListings";
import Favorites from "@/pages/Favorites";
import Messages from "@/pages/Messages";
import Chat from "@/pages/Chat";
import Offers from "@/pages/Offers";
import SellerProfile from "@/pages/SellerProfile";
import Pay from "@/pages/Pay";
import Profile from "@/pages/Profile";
import EditProfile from "@/pages/EditProfile";
import Notices from "@/pages/Notices";
import NotificationSettings from "@/pages/NotificationSettings";
import Privacy from "@/pages/Privacy";
import Support from "@/pages/Support";
import DeleteAccount from "@/pages/DeleteAccount";
import Admin from "@/pages/Admin";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 15000 } },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/banned" element={<Banned />} />

            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/listing/:id" element={<ListingDetail />} />
              <Route path="/seller/:id" element={<SellerProfile />} />
              <Route path="/privacy" element={<Privacy />} />

              <Route path="/create" element={<RequireAuth><CreateListing /></RequireAuth>} />
              <Route path="/edit/:id" element={<RequireAuth><EditListing /></RequireAuth>} />
              <Route path="/my-listings" element={<RequireAuth><MyListings /></RequireAuth>} />
              <Route path="/favorites" element={<RequireAuth><Favorites /></RequireAuth>} />
              <Route path="/messages" element={<RequireAuth><Messages /></RequireAuth>} />
              <Route path="/chat/:id" element={<RequireAuth><Chat /></RequireAuth>} />
              <Route path="/offers/:id" element={<RequireAuth><Offers /></RequireAuth>} />
              <Route path="/pay/:id" element={<RequireAuth><Pay /></RequireAuth>} />
              <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
              <Route path="/edit-profile" element={<RequireAuth><EditProfile /></RequireAuth>} />
              <Route path="/notices" element={<RequireAuth><Notices /></RequireAuth>} />
              <Route path="/notification-settings" element={<RequireAuth><NotificationSettings /></RequireAuth>} />
              <Route path="/support" element={<Support />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
